module.exports = __webpack_public_path__ + "static/media/funiwinlogo.04562cd9.svg";